import { gql, graphQueryBang } from "shared/lib/graphql"

const SendPinToMobileActivateChannels = gql`
  mutation SendPinToMobileActivateChannels(
    $channel_module_name: String!
    $email_address: String
    $phone_number: String
  ) {
    sendPinToMobileActivateChannels(
      input: { channel_module_name: $channel_module_name, email_address: $email_address, phone_number: $phone_number }
    ) {
      errors {
        attribute
        message
      }
      status
    }
  }
`

const NewPinActivateLiveChannel = gql`
  mutation NewPinActivateLiveChannel(
    $channel_module_name: String!
    $email_address: String
    $phone_number: String
    $pin: String!
  ) {
    newPinActivateLiveChannel(
      input: {
        channel_module_name: $channel_module_name
        email_address: $email_address
        phone_number: $phone_number
        pin: $pin
      }
    ) {
      errors {
        attribute
        message
      }
      status
    }
  }
`

interface Attrs {
  channel_module_name: string
  phone_number?: string
  email_address?: string
  pin?: string
}

const sendPin = async (moduleName: string, identifier: string) => {
  const attrs: Attrs = { channel_module_name: moduleName }
  if (["sms", "phone_call"].includes(moduleName)) {
    attrs.phone_number = identifier
  } else {
    attrs.email_address = identifier
  }

  return await graphQueryBang(SendPinToMobileActivateChannels, attrs)
}

const activateWithPin = async (moduleName: string, identifier: string, pin: string) => {
  const attrs: Attrs = { channel_module_name: moduleName, pin }
  if (["sms", "phone_call"].includes(moduleName)) {
    attrs.phone_number = identifier
  } else {
    attrs.email_address = identifier
  }

  return await graphQueryBang(NewPinActivateLiveChannel, attrs)
}

export { sendPin, activateWithPin }
